export class Cedente {
  public CedenteId: string;
  public ContaId: string;
  public Descricao: string;
  public DataCadastro: string;
  public DataModificacao: string;
  public UsuarioModificacaoId: string;
  public Banco: string;
  public RazaoSocial: string;
  public CpfCnpj: string;
  public Agencia: string;
  public ContaNumero: string;
  public ContaDigito: string;
  public NumeroCedente: string;
  public Carteira: string;
  public CodigoConvenio: string;
  public CodigoTransmissao: string;
  public Padrao: boolean;
  public Validacao: any;
}
